(() => {
  if (window.__everideHeaderScrollReady) return;
  window.__everideHeaderScrollReady = true;

  let lastY = Math.max(window.scrollY || 0, 0);
  let ticking = false;
  const mobileQuery = window.matchMedia('(max-width: 989px)');

  const allHeaders = () => Array.from(document.querySelectorAll('.ev-header'));
  const stickyHeaders = () => Array.from(document.querySelectorAll('.ev-header--sticky'));
  const mobileMenus = () => Array.from(document.querySelectorAll('.ev-header__mobile'));
  const headerGroup = () => document.querySelector('#header-group');
  const announcementBar = () => headerGroup()?.querySelector('.everide-announcement-bar');

  const isLockedOpen = (header) => {
    return Boolean(
      header.querySelector('.ev-header__mobile[open], .ev-header__locale[open]') ||
      header.matches(':focus-within')
    );
  };

  const syncMobileMenuState = () => {
    const isOpen = mobileQuery.matches && mobileMenus().some((menu) => menu.open);
    document.documentElement.classList.toggle('everide-mobile-drawer-open', isOpen);

    mobileMenus().forEach((menu) => {
      const summary = menu.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
    });
  };

  /*
   * The announcement bar stays in document flow. The main mobile header is fixed.
   * While the announcement is visible, the header sits directly below it.
   * As the announcement scrolls off-screen, the header follows it upward and then pins at top: 0.
   */
  const syncMobileHeaderPosition = () => {
    const group = headerGroup();
    if (!group) return;

    if (!mobileQuery.matches) {
      group.style.removeProperty('--everide-mobile-header-height');
      allHeaders().forEach((header) => header.style.removeProperty('--everide-mobile-header-top'));
      return;
    }

    const bar = announcementBar();
    const barBottom = bar ? Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) : 0;
    let maxHeaderHeight = 0;

    allHeaders().forEach((header) => {
      header.classList.remove('ev-header--hidden');
      header.style.setProperty('--everide-mobile-header-top', `${barBottom}px`);

      const height = Math.ceil(header.getBoundingClientRect().height || header.offsetHeight || 62);
      maxHeaderHeight = Math.max(maxHeaderHeight, height);
    });

    if (maxHeaderHeight > 0) {
      group.style.setProperty('--everide-mobile-header-height', `${maxHeaderHeight}px`);
    }
  };

  const syncMobileDrawers = () => {
    allHeaders().forEach((header) => {
      const mobile = header.querySelector('.ev-header__mobile');
      if (!mobile) return;

      if (!mobileQuery.matches) {
        mobile.style.removeProperty('--everide-mobile-drawer-top');
        mobile.style.removeProperty('--everide-mobile-drawer-height');
        return;
      }

      const top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      mobile.style.setProperty('--everide-mobile-drawer-top', `${top}px`);
      mobile.style.setProperty('--everide-mobile-drawer-height', `${Math.max(0, window.innerHeight - top)}px`);
    });
  };

  const closeMobileMenus = (restoreFocus = false) => {
    mobileMenus().forEach((menu) => {
      if (!menu.open) return;
      menu.open = false;
      if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
    });
    syncMobileMenuState();
    syncMobileHeaderPosition();
    syncMobileDrawers();
  };

  const revealAll = () => {
    allHeaders().forEach((header) => header.classList.remove('ev-header--hidden'));
    syncMobileHeaderPosition();
    syncMobileDrawers();
    syncMobileMenuState();
  };

  const update = () => {
    const y = Math.max(window.scrollY || 0, 0);
    const delta = y - lastY;

    allHeaders().forEach((header) => {
      header.classList.toggle('ev-header--scrolled', y > 10);
    });

    if (mobileQuery.matches) {
      allHeaders().forEach((header) => header.classList.remove('ev-header--hidden'));
    } else {
      stickyHeaders().forEach((header) => {
        if (y < 72 || isLockedOpen(header)) {
          header.classList.remove('ev-header--hidden');
          return;
        }

        if (delta > 7 && y > 120) {
          header.classList.add('ev-header--hidden');
        } else if (delta < -4) {
          header.classList.remove('ev-header--hidden');
        }
      });
    }

    syncMobileHeaderPosition();
    syncMobileDrawers();
    lastY = y;
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });

  document.addEventListener('click', (event) => {
    const backdrop = event.target.closest?.('.ev-header__drawer-backdrop');
    if (!backdrop) return;
    const menu = backdrop.closest('.ev-header__mobile');
    if (menu?.open) menu.open = false;
    syncMobileMenuState();
    syncMobileHeaderPosition();
    syncMobileDrawers();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (!mobileMenus().some((menu) => menu.open)) return;
    closeMobileMenus(true);
  });

  document.addEventListener('toggle', (event) => {
    if (!(event.target instanceof HTMLDetailsElement)) return;
    if (event.target.open) {
      allHeaders().forEach((header) => header.classList.remove('ev-header--hidden'));
    }
    syncMobileHeaderPosition();
    syncMobileDrawers();
    syncMobileMenuState();
  }, true);

  window.addEventListener('pageshow', revealAll);
  document.addEventListener('shopify:section:load', revealAll);

  const onMobileChange = () => {
    if (!mobileQuery.matches) closeMobileMenus(false);
    revealAll();
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', onMobileChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(onMobileChange);
  }

  update();
  syncMobileMenuState();
})();
